module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "q_main_content"
  }, [_c('div', {
    staticClass: "q_content"
  }, [_c('div', {
    staticClass: "pos"
  }, [_c('div', {
    staticClass: "pos-content"
  }, [_c('div', {
    staticClass: "window"
  }, [_c('div', {
    staticClass: "subwindow"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix screens"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "product-screen screen"
  }, [_c('div', {
    staticClass: "leftpane"
  }, [_c('div', {
    staticClass: "window"
  }, [_c('div', {
    staticClass: "subwindow"
  }, [_c('div', {
    staticClass: "subwindow-container"
  }, [_c('div', {
    staticClass: "subwindow-container-fix"
  }, [_c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    staticClass: "order-scroller touch-scrollable"
  }, [_c('div', {
    staticClass: "order"
  }, [_c('ul', {
    staticClass: "orderlines"
  }, _vm._l((_vm.listCart), function(row, i) {
    return _c('li', {
      key: i,
      staticClass: "orderline"
    }, [_c('span', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(_vm.displayNumber(row.qty * row.price)))]), _vm._v(" "), _c('ul', {
      staticClass: "info-list"
    }, [_c('li', {
      staticClass: "info"
    }, [_c('em', [_vm._v(_vm._s(_vm.displayNumber(row.qty)) + " ")]), _vm._v(_vm._s(row.uom) + " at " + _vm._s(_vm.displayNumber(row.price)) + "/" + _vm._s(row.uom) + "\n                                                        ")])])])
  })), _vm._v(" "), (this.emptyCartStatus != _vm.EMPTY_CART) ? _c('div', {
    staticClass: "summary clearfix"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "entry total"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total: ")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalAmount))]), _vm._v(" "), _c('div', {
    staticClass: "subentry"
  }, [_vm._v("Taxes: "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.taxAmount))])])])])]) : _vm._e(), _vm._v(" "), (this.emptyCartStatus === _vm.EMPTY_CART) ? _c('div', {
    staticClass: "order-empty"
  }, [_c('i', {
    staticClass: "icon ion-shopping-cart"
  }), _vm._v(" "), _c('h1', [_vm._v("Your shopping cart is empty")])]) : _vm._e()])])])])])])])]), _vm._v(" "), _vm._m(1)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale-screen screen oe_hidden"
  }, [_c('div', {
    staticClass: "screen-content"
  }, [_c('div', {
    staticClass: "top-content"
  }, [_c('span', {
    staticClass: "button back"
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind"
  }), _vm._v("\n                                Back\n                            ")]), _vm._v(" "), _c('h1', {
    staticClass: "product-name"
  }, [_vm._v("Unnamed Product")])]), _vm._v(" "), _c('div', {
    staticClass: "centered-content"
  }, [_c('div', {
    staticClass: "weight js-weight"
  }, [_vm._v("\n                                0.000 Kg\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("\n                                Rp 0.00/\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "computed-price"
  }, [_vm._v("\n                                123.14 €\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-product"
  }, [_vm._v("\n                                Order\n                                "), _c('i', {
    staticClass: "icon ion-ios-fastforward"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center rightpane"
  }, [_c('div', {
    staticClass: "qris",
    attrs: {
      "id": "qrcode"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7645d528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PointOfSales/PointOfSalesCustomer.vue
// module id = 799
// module chunks = 1